import * as constants from 'common/constants';

export const DEFAULT_STATE = {
  firstName: '',
  lastName: '',
  email: '',
  isLoggedIn: false,
  error: {},
};

export default (state = DEFAULT_STATE, { type, payload }) => {
  switch (type) {
    case constants.LOGIN_SUCCESS: {
      const { attributes } = payload;
      const firstName =
        (attributes && attributes.given_name) || DEFAULT_STATE.firstName;
      const lastName =
        (attributes && attributes.family_name) || DEFAULT_STATE.lastName;
      const emailAddress =
        (attributes && attributes.email) || DEFAULT_STATE.email;
      return {
        ...state,
        firstName,
        lastName,
        isLoggedIn: true,
        email: emailAddress,
      };
    }

    case constants.LOGOUT_SUCCESS:
      return {
        ...state,
        firstName: '',
        lastName: '',
        email: '',
        isLoggedIn: false,
      };

    case constants.REGISTER_SUCCESS:
      return {
        ...state,
        email: payload.user && payload.user.username,
      };
    case constants.FORGOT_PASSWORD_PENDING:
      return {
        ...state,
        email: payload,
      };
    case constants.LOGIN_FAILED:
      return {
        ...state,
        error: payload.error,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/auth.js